import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {Injectable} from '@angular/core';
import {FormDefinitionFieldSummaryConverter} from '../../../../field/api/entity/converter/formDefinitionFieldSummary.converter';
import {FormDefinitionGroupFieldModel} from '../formDefinitionGroupField.model';
import {FormDefinitionFieldConverter} from '../../../../field/api/entity/converter/formDefinitionField.converter';

@Injectable()
export class FormDefinitionGroupFieldConverter extends HttpModelConverter<FormDefinitionGroupFieldModel> {

    constructor(private fieldConverter: FormDefinitionFieldConverter) {
        super();
    }

    protected createInstance(): FormDefinitionGroupFieldModel {
        return new FormDefinitionGroupFieldModel();
    }

    protected enrichObject(result: FormDefinitionGroupFieldModel, src: FormDefinitionGroupFieldModel) {
        result.fieldDefinition = this.fieldConverter.convert(result.fieldDefinition);
    }

}
